import { atom } from 'recoil';

type View = {
  current: string;
};

export const ChannelInfoViewState = atom<View>({
  key: 'CHANNEL_INFO_VIEW_STATE',
  default: { current: '' },
});
